import fonts, { fontList } from './styles/font-face'
import theme, { Theme } from './theme'

export { fonts, fontList, theme }
export type { Theme }
